import { useState, useEffect } from "react";

export function useCheck(apiFunc) {
	const [isAvailable, setIsAvailable] = useState(false);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const checkValue = async (value) => {
		if(!value) {
			return false;
		}

		setLoading(true);
		setError(null);

		try {
			const response = await apiFunc(value);
			setIsAvailable(response.isAvailable);
			return response.isAvailable;
		} catch (error) {
			setError({
				status: error.response?.status,
				data: error.response?.data,
				code: error.response?.data?.errorCode
			});
			setIsAvailable(false);
			// TODO: 에러 분기 필요 - ex 사용 불가능한 id/email
		} finally {
			setLoading(false);
		}
	};

	const reset = () => {
		setIsAvailable(false);
		setLoading(true);
		setError(null);
	};
	
	return { isAvailable, loading, error, checkValue, reset };
};